
# Wenn in einer Zeile eine Lösch-Aktion erfolgreich war,
# dann die Zeile aus der Tabelle entfernen
$("table").on "ajax:success", "a[data-method=delete][data-remote=true]", (event, xhr) ->
  tr = $(this).closest("tr")
  tr.fadeOut ->
    tr.remove()
